import React , {useState, useEffect}from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Procesando from '../Generales/Procesando'
import {sucursal} from '../Generales/Storage';

function ConfiguracionDTE(props) {
const [tipoDocumentos, setTipoDocumentos] =  useState([]);
const [cargando, setCargando] = useState(false);

useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    getDatos()
},[]);

async function getDatos(){
    setCargando(true);
    await axios.get(config.api_url+'/configuracion/dte/?sucursalId='+sucursal.id ).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            setTipoDocumentos(resp.data.tipoDocumentos);
            setCargando(false);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al traer los datos!");
    })  
}

function ModificaInicio(indice, valor){
    const tipos_ = [...tipoDocumentos];
    tipos_[indice].inicial= valor;
    setTipoDocumentos(tipos_);
}

function ModificaFin(indice, valor){
    const tipos_ = [...tipoDocumentos];
    tipos_[indice].final= valor;
    setTipoDocumentos(tipos_);
}

function ModificaSiguiente(indice, valor){
    const tipos_ = [...tipoDocumentos];
    tipos_[indice].siguiente= valor;
    setTipoDocumentos(tipos_);
}

async function Guardar(){
    setCargando(true);
    await axios.post(config.api_url+'/configuracion/dte/', {tipoDocumentos:tipoDocumentos, sucursalId: sucursal.id }).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            toast.success("Parametros guardados!")
            setCargando(false);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al guardar los datos!");
    })  
}


return  (       
        <div className="contenedorMantenedor">
            <ToastContainer />
            <Modal
                open={cargando}
                showCloseIcon={false}
                center
                >
                <Procesando/>
            </Modal>
            <div className='card'>
                <div className='card-header'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <a href='/configuracion/home/'><i class="bi bi-arrow-left-short"></i>Regresar</a>   
                        </div>
                        <div className='col-md-4 titulo-formulario'>
                            <label>Configuración DTE </label>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='container'>
                                <table className="table table-striped">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th scope="col" className='col-md-3 col-3'>Tipo DTE</th>
                                            <th scope="col" className='col-md-3 col-3'>Folio Inicio</th>  
                                            <th scope="col" className='col-md-3 col-3'>Folio Termino</th> 
                                            <th scope="col" className='col-md-3 col-3'>Folio Siguiente</th>                   
                                        </tr>
                                    </thead>
                                        <tbody>
                                            {tipoDocumentos.map((tipo, indice) =>  
                                                <tr>
                                                    <td>
                                                        {tipo.nombre}
                                                    </td>
                                                    <td>
                                                        <input type="text" value={tipo.inicial} onChange={(ev)=>ModificaInicio(indice,ev.target.value)} className="form-control"></input>
                                                    </td>
                                                    <td>
                                                        <input type="text" value={tipo.final} onChange={(ev)=>ModificaFin(indice, ev.target.value )} className="form-control"></input>
                                                    </td>
                                                    <td>
                                                        <input type="text" value={tipo.siguiente} onChange={(ev)=>ModificaSiguiente(indice, ev.target.value )} className="form-control"></input>
                                                    </td>
                                                    
                                                </tr>
                                            ) 
                                            }  
                                        </tbody>
                                </table>

                            </div>  
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <button className='btn btn-formulario' onClick={Guardar}> Guardar </button>
                        </div>
                    </div>
                </div>
               
               
            </div>
           
        </div>
    
    );
}

export default ConfiguracionDTE;